// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsVacuumContol_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16 26C22.6274 26 28 20.6274 28 14C28 7.37258 22.6274 2 16 2C9.37258 2 4 7.37258 4 14C4 20.6274 9.37258 26 16 26ZM30 14C30 21.114 24.6939 26.9886 17.8235 27.8823L17 32H15L14.1765 27.8823C7.30606 26.9886 2 21.114 2 14C2 6.26801 8.26801 0 16 0C23.732 0 30 6.26801 30 14ZM26 15V14V13H25.9506C25.4489 7.94668 21.1853 4 16 4C10.8147 4 6.5511 7.94668 6.04938 13H6V14V15H10V13H8.06189C8.24404 11.5393 8.81996 10.2009 9.68008 9.09444L11.0501 10.4645L12.4644 9.05029L11.0943 7.68021C12.2008 6.82002 13.5393 6.24405 15 6.06189V8H17V6.06189C18.4606 6.24402 19.7988 6.81986 20.9053 7.67986L19.535 9.05014L20.9492 10.4644L22.3196 9.094C23.1799 10.2006 23.7559 11.5391 23.9381 13H22V15H26ZM17 16C17 16.5523 16.5523 17 16 17C15.4477 17 15 16.5523 15 16C15 15.4477 16 9 16 9C16 9 17 15.4477 17 16Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsVacuumContol is a generated icon component.
 */
let IconRmsVacuumContol = IconRmsVacuumContol_1 = class IconRmsVacuumContol extends IconBaseElement {
    render() {
        return html `${IconRmsVacuumContol_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsVacuumContol.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsVacuumContol = IconRmsVacuumContol_1 = __decorate([
    customElement('zui-icon-rms-vacuum-contol')
], IconRmsVacuumContol);
export { IconRmsVacuumContol };
